<div class="text-sm flex flex-col gap-6">
   <div class="flex gap-5">
      <div class="flex flex-col gap-1 flex-1">
         <app-basic-input
            [id]="'edit-title-input'"
            [required]="true"
            [inputFC]="titleFC"
            [label]="'project_title' | translate"
         >
         </app-basic-input>
         @if (titleFC?.touched && titleFC?.invalid) {
            <span class="input-error-message">{{ getErrorMessage(titleFC) | translate }}</span>
         }
      </div>

      <div class="flex flex-col gap-1 flex-1">
         <app-basic-input
            [id]="'ep-proposal-acronym-input'"
            [maxLength]="100"
            [required]="true"
            [inputFC]="acronymFC"
            [label]="'project_acronym' | translate"
         >
         </app-basic-input>
         @if (acronymFC?.touched && acronymFC?.invalid) {
            <span class="input-error-message">{{ getErrorMessage(acronymFC) | translate }}</span>
         }
      </div>

      <div class="flex flex-col gap-1 flex-1">
         <app-basic-dropdown
            [id]="'ep-proposal-type-of-action-select'"
            [required]="true"
            [optionValue]="'id'"
            [optionLabel]="'name'"
            [dropdownFC]="typeOfActionFC"
            [options]="typeOfActionArray"
            [label]="'type_of_action' | translate"
         ></app-basic-dropdown>
         @if (typeOfActionFC?.touched && typeOfActionFC?.invalid) {
            <span class="input-error-message">{{ getErrorMessage(typeOfActionFC) | translate }}</span>
         }
      </div>
   </div>
   <div class="flex gap-5">
      <div class="flex flex-col gap-1 flex-1">
         <app-basic-calendar
            [id]="'edit-deadline-input'"
            [required]="true"
            [calendarFC]="deadlineFC"
            [label]="'deadline' | translate"
         ></app-basic-calendar>

         @if (deadlineFC?.touched && deadlineFC?.invalid) {
            <span class="input-error-message">{{ getErrorMessage(deadlineFC) | translate }}</span>
         }
      </div>

      <div class="flex flex-col gap-1 flex-1">
         <app-basic-input
            [id]="'ep-proposal-duration-input'"
            [type]="'number'"
            [required]="true"
            [inputFC]="durationFC"
            [label]="'duration_months' | translate"
         >
         </app-basic-input>
         @if (durationFC?.touched && durationFC?.invalid) {
            <span class="input-error-message">{{
               durationFC?.hasError('pattern')
                  ? ('error_input_onlyNumbers' | translate)
                  : durationFC?.hasError('max')
                    ? 'Max value is 180'
                    : (getErrorMessage(durationFC) | translate)
            }}</span>
         }
      </div>

      <div class="flex flex-col gap-2 flex-1">
         <app-basic-slider
            [id]="'ep-proposal-funding-rate-input'"
            [sliderFC]="foundingFC"
            [label]="'funding_rate_for_action' | translate"
         ></app-basic-slider>
      </div>
   </div>
   <div class="flex gap-8">
      <div class="flex flex-col gap-1 flex-1 min-w-0">
         <label class="text-[13px]">{{ 'additional_info' | translate }}</label>
         <app-basic-editor
            [id]="'ep-proposal-call-information-editor'"
            [scrollable]="true"
            [editorFC]="callOfTheProposalFC"
         >
         </app-basic-editor>
         @if (callOfTheProposalFC?.touched && callOfTheProposalFC?.invalid) {
            <span class="input-error-message">{{ getErrorMessage(callOfTheProposalFC) | translate }} 2048</span>
         }
      </div>
      <div class="flex flex-col gap-1 flex-1 min-w-0">
         <label class="text-[13px]">{{ 'general_objectives' | translate }}</label>
         <app-basic-editor
            [id]="'ep-proposal-general-objectives-editor'"
            [scrollable]="true"
            [editorFC]="generalObjectivesFC"
         >
         </app-basic-editor>
      </div>
   </div>
</div>
